/**
 * Models API
 *
 * API calls for model configuration
 * Reference: api/routers/admin/models.py
 */

import { apiClient } from './client';
import type { ModelInfo, AllModelsResponse } from '@/types';

const BASE_PATH = '/models';

export const modelsApi = {
  /**
   * Get all available chat models
   */
  listChatModels: async (): Promise<ModelInfo[]> => {
    const response = await apiClient.get(`${BASE_PATH}/chat`);
    return response.data;
  },

  /**
   * Get all available memory/summary models
   */
  listMemoryModels: async (): Promise<ModelInfo[]> => {
    const response = await apiClient.get(`${BASE_PATH}/memory`);
    return response.data;
  },

  /**
   * Get all available embedding models
   */
  listEmbeddingModels: async (): Promise<ModelInfo[]> => {
    const response = await apiClient.get(`${BASE_PATH}/embedding`);
    return response.data;
  },

  /**
   * Get all model options in a single call
   */
  listAllModels: async (): Promise<AllModelsResponse> => {
    const response = await apiClient.get(`${BASE_PATH}/all`);
    return response.data;
  },
};
